export default __webpack_public_path__ + "static/A1-d4e892d575d3cc47e2bf26cf41fad0d6.png";